import React from 'react';

const Step4 = ({
  formValues,
  handleChange,
  handlePrevStep,
  handleSubmit,
  errors,
}) => {
  return (
    <div className="flex flex-col gap-4 w-full h-full">
      <div className="flex flex-col h-full w-full gap-4">
        {/* Name Input */}
        <div className="relative">
          <input
            type="text"
            name="name"
            value={formValues.name}
            onChange={handleChange}
            placeholder="Name"
            className={`w-full p-2 rounded-lg bg-white border-2 ${errors.name
              ? 'border-red-500'
              : 'border-primary'}`}
          />
          {errors.name && (
            <div className="absolute bottom-[-20px] text-red-500">
              <i className="fas fa-exclamation-circle mr-1"></i>
              {errors.name}
            </div>
          )}
        </div>

        {/* Email Input */}
        <div className="relative">
          <input
            type="email"
            name="email"
            value={formValues.email}
            onChange={handleChange}
            placeholder="Email"
            className={`w-full p-2 rounded-lg bg-white border-2 ${errors.email
              ? 'border-red-500'
              : 'border-primary'}`}
          />
          {errors.email && (
            <div className="absolute bottom-[-20px] text-red-500">
              <i className="fas fa-exclamation-circle mr-1"></i>
              {errors.email}
            </div>
          )}
        </div>

        {/* Phone Input */}
        <div className="relative">
          <input
            type="tel"
            name="phone"
            value={formValues.phone}
            onChange={handleChange}
            placeholder="Phone (123-456-7890)"
            className={`w-full p-2 rounded-lg bg-white border-2 ${errors.phone
              ? 'border-red-500'
              : 'border-primary'}`}
          />
          {errors.phone && (
            <div className="absolute bottom-[-20px] text-red-500">
              <i className="fas fa-exclamation-circle mr-1"></i>
              {errors.phone}
            </div>
          )}
        </div>

        {/* Address Input */}
        <div className="relative">
          <input
            type="text"
            name="address"
            value={formValues.address}
            onChange={handleChange}
            placeholder="Address"
            className={`w-full p-2 rounded-lg bg-white border-2 ${errors.address
              ? 'border-red-500'
              : 'border-primary'}`}
          />
          {errors.address && (
            <div className="absolute bottom-[-20px] text-red-500">
              <i className="fas fa-exclamation-circle mr-1"></i>
              {errors.address}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step4;
